function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-4{fill:none;stroke:#5369b0;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:24px;}.cls-3{stroke-width:40px;}.cls-4{stroke-width:12px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, React.createElement("polygon", {
  className: "cls-2",
  points: "669.15 300 401.33 455.64 131.75 300 399.57 144.36 669.15 300"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, React.createElement("polygon", {
  className: "cls-3",
  points: "534.58 300 400.66 377.82 265.88 300 399.79 222.18 534.58 300"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, React.createElement("polyline", {
  className: "cls-4",
  points: "669.15 370 401.33 525.64 131.75 370"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, React.createElement("polyline", {
  className: "cls-4",
  points: "669.15 440 401.33 595.64 131.75 440"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-1"
}, React.createElement("polyline", {
  className: "cls-4",
  points: "669.15 500 401.33 655.64 131.75 500"
}));

var SvgGeodataLogo = function SvgGeodataLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeodataLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/geodata_logo.b0763f0e.svg";
export { ForwardRef as ReactComponent };